import React, { useState, useRef } from 'react';
import { Layout, Typography, Switch } from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';
import './styles/main.css';
import AESForm from './components/AESForm';
import HistoryRecord from './components/HistoryRecord';
import BruteForceDecrypt from './components/BruteForceDecrypt';

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

function App() {
  const [isBruteForceMode, setIsBruteForceMode] = useState(false);

  // 创建对AESForm组件的引用
  const aesFormRef = useRef();
  
  // 创建对HistoryRecord组件的引用
  const historyRecordRef = useRef();
  
  // 处理从历史记录选择的数据
  const handleSelectRecord = (record) => {
    if (aesFormRef.current && aesFormRef.current.setFormValues) {
      aesFormRef.current.setFormValues(record);
    }
  };
  
  // 提供给AESForm组件的回调函数，用于通知历史记录需要刷新
  const handleHistoryUpdate = () => {
    if (historyRecordRef.current && historyRecordRef.current.refreshHistory) {
      historyRecordRef.current.refreshHistory();
    }
  };

  // 动画变体定义
  const headerVariants = {
    initial: { y: -20, opacity: 0 },
    animate: { 
      y: 0, 
      opacity: 1,
      transition: { 
        type: "spring", 
        stiffness: 300, 
        damping: 30,
        delay: 0.1
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        duration: 0.5,
        staggerChildren: 0.1
      } 
    }
  };

  const pageTransition = {
    initial: { x: 50, opacity: 0 },
    animate: { 
      x: 0, 
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 30 }
    },
    exit: { 
      x: -50, 
      opacity: 0,
      transition: { duration: 0.2 } 
    }
  };

  return (
    <Layout className="app-container">
      <motion.div
        initial="initial"
        animate="animate"
        variants={headerVariants}
      >
        <Header className="app-header" style={{
          background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Title level={2} style={{ color: 'white', margin: 0 }}>
            AES在线加解密工具
          </Title>
          <motion.div 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px'
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span style={{ 
              color: 'rgba(255, 255, 255, 0.85)',
              fontSize: '14px'
            }}>
              一把梭模式
            </span>
            <Switch
              checked={isBruteForceMode}
              onChange={setIsBruteForceMode}
              size="small"
            />
          </motion.div>
        </Header>
      </motion.div>

      <Content className="app-content">
        <motion.div 
          className="container"
          initial="hidden"
          animate="visible"
          variants={contentVariants}
        >
          <AnimatePresence mode="wait">
            {isBruteForceMode ? (
              <motion.div
                key="bruteforce"
                initial="initial"
                animate="animate"
                exit="exit"
                variants={pageTransition}
              >
                <BruteForceDecrypt />
              </motion.div>
            ) : (
              <motion.div
                key="aesform"
                initial="initial"
                animate="animate"
                exit="exit"
                variants={pageTransition}
              >
                <AESForm 
                  ref={aesFormRef} 
                  onHistoryUpdate={handleHistoryUpdate}
                />
              </motion.div>
            )}
          </AnimatePresence>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            <HistoryRecord 
              ref={historyRecordRef}
              onSelectRecord={handleSelectRecord} 
            />
          </motion.div>
        </motion.div>
      </Content>
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <Footer className="app-footer">
          <p>AES在线加解密工具 ©2024</p>
        </Footer>
      </motion.div>
    </Layout>
  );
}

export default App;
